var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Artboard_30",
    "data-name": "Artboard 30",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58,7H56V5a4,4,0,0,0-8,0V7H46V5a4,4,0,0,0-8,0V7H36V5a4,4,0,0,0-8,0V7H26V5a4,4,0,0,0-8,0V7H16V5A4,4,0,0,0,8,5V7H6a5.006,5.006,0,0,0-5,5V60a3,3,0,0,0,3,3H60a3,3,0,0,0,3-3V12A5.006,5.006,0,0,0,58,7ZM50,5a2,2,0,0,1,4,0v5a2,2,0,0,1-4,0ZM40,5a2,2,0,0,1,4,0v5a2,2,0,0,1-4,0ZM30,5a2,2,0,0,1,4,0v5a2,2,0,0,1-4,0ZM20,5a2,2,0,0,1,4,0v5a2,2,0,0,1-4,0ZM10,5a2,2,0,0,1,4,0v5a2,2,0,0,1-4,0ZM6,9H8v1a4,4,0,0,0,8,0V9h2v1a4,4,0,0,0,8,0V9h2v1a4,4,0,0,0,8,0V9h2v1a4,4,0,0,0,8,0V9h2v1a4,4,0,0,0,8,0V9h2a3,3,0,0,1,3,3v6H3V12A3,3,0,0,1,6,9ZM7,20H57V55a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1ZM60,61H4a1,1,0,0,1-1-1V20H5V55a3,3,0,0,0,3,3H56a3,3,0,0,0,3-3V20h2V60A1,1,0,0,1,60,61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30h5a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v4A2,2,0,0,0,13,30Zm0-6h5v4H13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30h5a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v4A2,2,0,0,0,24,30Zm0-6h5v4H24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35,30h5a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H35a2,2,0,0,0-2,2v4A2,2,0,0,0,35,30Zm0-6h5v4H35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46,30h5a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H46a2,2,0,0,0-2,2v4A2,2,0,0,0,46,30Zm0-6h5v4H46Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13,40h5a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v4A2,2,0,0,0,13,40Zm0-6h5v4H13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24,40h5a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v4A2,2,0,0,0,24,40Zm0-6h5v4H24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35,40h5a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2H35a2,2,0,0,0-2,2v4A2,2,0,0,0,35,40Zm0-6h5v4H35Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46,40h5a2,2,0,0,0,2-2V34a2,2,0,0,0-2-2H46a2,2,0,0,0-2,2v4A2,2,0,0,0,46,40Zm0-6h5v4H46Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13,50h5a2,2,0,0,0,2-2V44a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v4A2,2,0,0,0,13,50Zm0-6h5v4H13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24,50h5a2,2,0,0,0,2-2V44a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v4A2,2,0,0,0,24,50Zm0-6h5v4H24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36,50h.045a1,1,0,0,0,.723-.359l5-6-1.536-1.28-4.3,5.159-2.226-2.226-1.414,1.414,3,3A1,1,0,0,0,36,50Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47,50h.045a1,1,0,0,0,.723-.359l5-6-1.536-1.28-4.3,5.159-2.226-2.226-1.414,1.414,3,3A1,1,0,0,0,47,50Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bd9420d26f7a73fb9031aa48d6466e74.svg";
export { ForwardRef as ReactComponent };